function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const GridSolicitudEmail = ({setGrid, solicitudes = [], handleSubmit, handleEdit, values, setFieldValue, handleVentanaGrados, handleSeleccionado}) => {
    
    return (
        <div className="sm:px-6 lg:px-8 bg-primarioMira p-2 pb-0 rounded-lg shadow-2xl  divide-grisMira border border-grisMira">
            <div className="sm:flex sm:items-center">
                <div className="sm:flex-auto">
                    <h1 className="text-lg font-semibold text-white">Solicitudes</h1>
                    <p className="mt-2 text-sm text-grisMira">
                        Lista detallada de solicitudes ingresadas.
                    </p>
                </div>
            </div>
            <div className="mt-2 flex flex-col">
                <div className=" sm:-mx-6 lg:-mx-8 overflow-auto">
                    <div className="inline-block min-w-full align-middle">
                        <div className="shadow-sm ring-1 ring-black ring-opacity-5">
                            <table className="min-w-full border-separate" style={{ borderSpacing: 0 }}>
                                <thead className="bg-secundarioMira">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira"
                                        >
                                            Solicitud
                                        </th>
                                        <th
                                            scope="col"
                                            className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8"
                                        >
                                            Carnet
                                        </th>
                                        <th
                                            scope="col"
                                            className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8"
                                        >
                                            Aspirante
                                        </th>
                                        <th
                                            scope="col"
                                            className="sticky top-0 z-10 bg-secundarioMira  border-b border-gray-300 px-3 py-3.5 text-center text-sm font-semibold text-grisMira "
                                        >
                                            Sede
                                        </th>
                                        <th
                                            scope="col"
                                            className="sticky top-0 z-10 bg-secundarioMira  border-b border-gray-300 px-3 py-3.5 text-center text-sm font-semibold text-grisMira"
                                        >
                                            Grado
                                        </th>
                                        <th
                                            scope="col"
                                            className="sticky top-0 z-10 bg-secundarioMira  border-b border-gray-300 px-3 py-3.5 text-center text-sm font-semibold text-grisMira "
                                        >
                                            Estado
                                        </th>
                                        <th
                                            scope="col"
                                            className="sticky top-0 z-10 bg-secundarioMira  border-b border-gray-300 px-3 py-3.5 text-center text-sm font-semibold text-grisMira "
                                        >Solicitud
                                            <span className="sr-only">Editar</span>
                                        </th>
                                        <th
                                            scope="col"
                                            className="sticky top-0 z-10 bg-secundarioMira  border-b border-gray-300 px-3 py-3.5 text-center text-sm font-semibold text-grisMira "
                                        >Continuar con <br></br>el proceso
                                            <span className="sr-only">Seleccionar</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-secundarioMira">
                                    {solicitudes.map((solicitud, Idx) =>
                                        <tr key={Idx}>
                                            {/* <td
                                                className={classNames(
                                                    Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pl-4 text-sm font-medium text-white'
                                                )}
                                            >
                                            </td> */}
                                            <td
                                                className={classNames(
                                                    Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {solicitud.Id}
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {solicitud.Carnet}
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {solicitud.Nombres} {solicitud.Apellidos}
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {solicitud.Sede}
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {solicitud.Grado}
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {solicitud.EstadoSolicitud}
                                            </td>
                                            {
                                                //(solicitud.EstadoSolicitud === 'Prospecto' || solicitud.EstadoSolicitud === 'Pendiente de pago' || solicitud.EstadoSolicitud === 'Pendiente pago de inscripción'  || solicitud.EstadoSolicitud === 'Pendiente de entrevista') 
                                            (solicitud.EstadoSolicitud !== 'Inscrito' ) 
                                            ? (
                                                <>
                                                    <td
                                                        className={classNames(
                                                            Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                            'relative whitespace-nowrap py-2 pr-4 pl-3 text-center text-sm font-medium'
                                                        )}
                                                    >
                                                        {
                                                            solicitud.EstadoSolicitud === 'Pendiente pago de inscripción'?null:
                                                        <button
                                                        className="text-secundario hover:underline"
                                                        type="button"
                                                        onClick={() => {handleEdit(values, setFieldValue, solicitud); handleVentanaGrados(solicitud);handleSeleccionado(true)}}
                                                        >
                                                            Editar
                                                            <span className="sr-only">, {solicitud.Id} </span>
                                                        </button>
                                                        }

                                                    </td><td
                                                        className={classNames(
                                                            Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                            'relative whitespace-nowrap py-2 pr-4 pl-3 text-center text-sm font-medium'
                                                        )}
                                                    >
                                                        <button
                                                            className="text-azulBrillanteMira hover:underline"
                                                            type="button"
                                                            onClick={() => {handleSubmit(values, setFieldValue, false, solicitud.Id, solicitud.Carnet, null,null,solicitud.EstadoSolicitud); handleVentanaGrados(solicitud);handleSeleccionado(true)}}
                                                        >
                                                            Seleccionar
                                                            <span className="sr-only">, {solicitud.Id} </span>
                                                        </button>
                                                    </td>
                                                </>) : (
                                                <>
                                                    <td
                                                        className={classNames(
                                                            Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                            'relative whitespace-nowrap py-2 pr-4 pl-3 text-right text-sm font-medium'
                                                        )}
                                                    >
                                                    </td><td
                                                        className={classNames(
                                                            Idx !== solicitud.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                            'relative whitespace-nowrap py-2 pr-4 pl-3 text-right text-sm font-medium'
                                                        )}
                                                    >
                                                    </td>
                                                </>)
                                            }
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GridSolicitudEmail